import { mapActions, mapMutations } from 'vuex';
import { PRODUCTS_ORDER_KEY, PROMOTION_BTN_TYPE } from '@/helpers';

export default {
  name: 'PromotionsCard',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      PROMOTION_BTN_TYPE,
      PRODUCTS_ORDER_KEY
    };
  },
  computed: {
    toLink() {
      let { brand, basketIds, id } = this.data;

      let link = { name: 'products', query: { orderby: PRODUCTS_ORDER_KEY.WITH_PROMOTIONS } };

      if (basketIds.length) {
        link = { name: 'products-promo', params: { id } };
      } else if (brand) {
        link = {
          name: 'brand',
          params: { seria: brand.slug },
          query: { orderby: PRODUCTS_ORDER_KEY.WITH_PROMOTIONS }
        };
      }
      return link;
    }
  },
  methods: {
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      modalOpen: 'app/MODAL_OPEN'
    }),
    ...mapActions({
      getPromotionsProductsForBasket: 'sales/GET_PROMOTIONS_PRODUCTS_FOR_BASKET'
    }),
    async onAddAllProductsToBasket() {
      let ids = this.data.basketIds.map(({ productId }) => productId);

      let response = await this.getPromotionsProductsForBasket({ ids });
      if (!response.data.length) return;

      response.data.map((product) => {
        let currentProduct = this.data.basketIds.find(({ productId }) => productId === product.id);
        if (!currentProduct) return;

        let currentProductPrice = product.productPrices.data.find(({ value }) => value === currentProduct.value);
        if (!currentProductPrice) return;

        this.addToBasket({
          select_count: 1,
          product_price: currentProductPrice,
          product: product
        });
      });
      this.modalOpen('basketModal');
    }
  }
};
